import React from 'react'
import './Document.css'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

function DocumentRow(props) {
  const {
    index,
    setSigner,
    document: { id, title, createdAt, dueDate, status, receivers },
  } = props
  const history = useHistory()

  const handleNavigateToDetail = () => {
    history.push('/viewDocumentDetails/' + id)
  }

  return (
    <tr>
      <td className='row-index'>{index + 1}</td>
      <td className='ellipsis-text clickable-title row-title' onClick={() => handleNavigateToDetail()}>
        {title}
      </td>
      <td className='row-created'>{moment(createdAt).format('ll')}</td>
      <td className='row-duedate'>
        {moment(dueDate).format('ll')}
        <br />({moment(dueDate).fromNow()})
      </td>
      <td className='row-status'>{status}</td>
      <td className='row-receiver'>
        <ol className='receiver-list'>
          {receivers.map((receiver, index) => {
            return (
              <li key={index} className='ellipsis-text'>
                <span className='clickable-title' onClick={() => setSigner(receiver.id)}>
                  {receiver.name}
                </span>
              </li>
            )
          })}
        </ol>
      </td>
    </tr>
  )
}

DocumentRow.propTypes = {
  index: PropTypes.number.isRequired,
  setSigner: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
}

export default DocumentRow
